import {useTranslation} from 'react-i18next';
import {Stack, Typography} from '@mui/material';
import {Modal, ModalProps} from '../modal/modal';
import {translations} from '../../i18n/translations';
import './senior-caregivers-listing.scss';

interface SeniorCaregiversListingModalProps extends Omit<ModalProps, 'actions'> {
  open: boolean;
  submitting: boolean;
  seniorName: string;
  caregiverName?: string;
  onClose: () => void;
  onRemove: () => void;
}

export const SeniorCaregiversListingModal = ({
  open,
  submitting,
  seniorName,
  caregiverName,
  onClose,
  onRemove,
}: SeniorCaregiversListingModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="caregivers-listing-modal"
      preventCloseClick
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.modal.confirm),
          type: 'nondestructive',
          onClick: onRemove,
          loading: submitting,
        },
      ]}
    >
      <Stack>
        <Typography className="title">
          {t(translations.senior_caregivers_listing.remove_relationship_dialog_title, {
            senior: seniorName,
            caregiver: caregiverName || '',
          })}
        </Typography>
        <Typography className="subtitle">
          {t(translations.senior_caregivers_listing.remove_relationship_dialog_message, {
            senior: seniorName,
            caregiver: caregiverName || '',
          })}
        </Typography>
      </Stack>
    </Modal>
  );
};
